import {observable, autorun, action} from 'mobx';
import {getRandomHexColor} from 'lib/helpers';

const SHEET_COLOR = 0xD98E55;
const SIDE_COLOR = 0x7B4922;
const SIDE_HOVER_COLOR = 0x4D2B10;

export default class Sheet {
  // @observable sheet = {
  //   width: 0,
  //   height: 0
  // };
  animate = null;
  stage = null;
  store = null;
  sheetGraphics = new PIXI.Graphics();
  sideGraphics = {
    left: new PIXI.Graphics(),
    right: new PIXI.Graphics(),
    top: new PIXI.Graphics(),
    bottom: new PIXI.Graphics(),
};
  @observable sheetFillColor = SHEET_COLOR;
  @observable sidesFillColors = {
    top: SIDE_COLOR,
    right: SIDE_COLOR,
    bottom: SIDE_COLOR,
    left: SIDE_COLOR
  };

  constructor(animate, stage, store) {
    this.stage = stage;
    this.store = store;
    this.animate = animate;

    this.createSheet();

    autorun(this.updateSheetGraphics);
    autorun(this.updateSideGraphics);
  }

  createSheet = () => {
    this.stage.addChild(this.sheetGraphics);
    this.createSideGraphics();
  };

  createSideGraphics = () => {
    for (let side in this.sideGraphics) {
      if (this.sideGraphics.hasOwnProperty(side)) {
        this.sideGraphics[side].interactive = true;
        this.sideGraphics[side].on('mouseover', () => this.setSideGraphicsFillColor(side, SIDE_HOVER_COLOR));
        this.sideGraphics[side].on('mouseout', () => this.setSideGraphicsFillColor(side, SIDE_COLOR));
        this.stage.addChild(this.sideGraphics[side]);
      }
    }
  };

  updateSheetGraphics = () => {
    // console.log('updateSheetGraphics');
    const {sheet} = this.store;
    this.sheetGraphics
      .clear()
      .beginFill(this.sheetFillColor, 1)
      .drawRect(0, 0, sheet.width, sheet.height)
      .endFill();
    this.animate();
  };

  updateSideGraphics = () => {
    // console.log('updateSideGraphics');
    const {sheet} = this.store;
    this.sideGraphics.top
      .clear()
      .beginFill(this.sidesFillColors.top)
      .drawRect(0, 0, sheet.width, sheet.top)
      .endFill();

    this.sideGraphics.right
      .clear()
      .beginFill(this.sidesFillColors.right)
      .drawRect(sheet.width - sheet.right, 0, sheet.right, sheet.height)
      .endFill();

    this.sideGraphics.bottom
      .clear()
      .beginFill(this.sidesFillColors.bottom)
      .drawRect(0, sheet.height - sheet.bottom, sheet.width, sheet.bottom)
      .endFill();

    this.sideGraphics.left
      .clear()
      .beginFill(this.sidesFillColors.left)
      .drawRect(0, 0, sheet.left, sheet.height)
      .endFill();
    this.animate()
  };

  @action setSideGraphicsFillColor = (sideGraphicName, color) => {
    this.sidesFillColors[sideGraphicName] = color;
  };

  @action setFillColor = (color) => {
    this.sheetFillColor = color;
  };
}


// WEBPACK FOOTER //
// ./src/views/SheetCalculator/Pixi/Sheet.js